import { LocalStorageService } from './../../core/services/local-storage.service';
import { environment } from './../../../environment/environment';
import { SortDataService } from './../../core/services/sortdata';
import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  addedIntervenant,
  associatedIntervenant,
  associatedIntervenant1,
  associatedIntervenant2,
  confirmDelete,
  emailExist,
  existedIntervenant,
  existedManager,
  personalEmailExist,
  phoneNumberExist,
  serverError,
  successDelete,
  updatedIntervenant,
} from './../../core/models/messages';
import { linkedInRegExp, patternEmail, patternfirstName } from './../../core/models/pattern';
import { CompanyService } from './../../core/services/company/company.service';
import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from 'ngx-intl-tel-input';

import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { catchError, debounceTime, distinctUntilChanged, Subject, switchMap, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { PageEvent } from '@angular/material/paginator';
import { IntervenantSelectedService } from '@core/services/company/intervenant-selected.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-list-users',
  templateUrl: './list-users.component.html',
  styleUrls: ['./list-users.component.css'],
})
export class ListUsersComponent {
  parentItem = 'Oups, Aucune donnée disponible pour le moment.';
  pageSize = 5;
  pageSizeOptions = [5, 10, 20];
  @Input() set fromCompany(value: boolean) {
    this.company = value;
  }
  @Input() intervenantDetails: any;
  company: boolean = false;
  showResetButtons: boolean = true;
  /* string */
  mode: string = 'create';
  intervenantId!: string;

  /* formGroup */
  /* form group */
  phoneForm: FormGroup = this.createFormPhone();
  intervenantForm: FormGroup = this.createIntervenantForm();

  /* string */
  url: string = environment.baseUrl + '/api';
  currentSortColumn: string = 'first_name';
  searchValue: string = '';
  sortAttr: string = '';
  searchElement: string = '';
  fileExtention: string = '';
  fileError: string = '';
  fileName: string = '';
  /* number */
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  currentPage: number = 0;
  totalItems!: number;
  startIndex: number = 0;
  endIndex: number = 5;
  idIntervenant!: string;
  selectedRoleId: number | null = null;
  /* any */
  listRole: { id: number; name: string }[] = [];
  listsubcategory: any;
  closeResult = '';
  p: number = 1;
  listIntervenant: any = [];
  PhoneNumberFormat = PhoneNumberFormat;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  separateDialCode: boolean = false;
  pagination : boolean =false;
  isESNConnected: boolean = true;
  typeCompany: any;
  /* modal */
  cvname: any;
  modalRef?: BsModalRef;
  idUser!: number;
  isDisabled = true;
  content: any;
  selecteemploye: any;
  file: any = '';
  isPhoneNumberValid: boolean = false;
  validPhoneNumber: boolean = false;
  isexistemail: boolean = false;
  isPhoneEnabled: boolean = true;
  searchFormGroup: FormGroup = this.createSearchForm();
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  private searchTerms = new Subject<string>();
  isLoadSpinner: boolean = true;

  @ViewChild('inputField', { static: true }) inputField!: ElementRef;
  isReadOnly = true;
  constructor(
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    private sortDataService: SortDataService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private localStorageService: LocalStorageService,
    private elRef: ElementRef,
    private intervenantSelectedService : IntervenantSelectedService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.searchTerms
        .pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap((searchName) => {
          const data = {
            email: searchName,
          };

            return this.companyService
            .getintervenant(data).pipe(
              catchError(() => {
                this.intervenantForm.patchValue({
                  first_name: '',
                  last_name: '',
                  linkedin_link: '',
                  cvname: '',
                });
                this.cvname = '';
                this.isexistemail = false;
                this.iscv = false;
                this.phoneForm.controls['phone'].enable();


                return [];
              })
            );
          })
        )
        .subscribe((res: any) => {
          if (res.data.length == 0) {
            this.intervenantForm.patchValue({
              first_name: '',
              last_name: '',
              linkedin_link: '',
              cvname: '',
            });
            this.cvname = '';
            this.phoneForm.controls['phone'].enable();
            this.phoneForm.controls['phone'].setValue('');
            this.isexistemail = false;
            this.iscv = false;
          } else {
            this.isexistemail = true;
            if (res.data[0].cv && res.data[0].cv !== 'null') {
              this.iscv = true;
            } else {
              this.iscv = false;
            }

            this.intervenantForm.patchValue({
              first_name: res.data[0].first_name,
              last_name: res.data[0].last_name,
              linkedin_link: res.data[0].linkedin_link,
              cvname: res.data[0].cv,
              phone_number: res.data[0].phone_number,
              emailProESN: res.data[0].emailProESN,
              emailProClient: res.data[0].emailProClient,
            });

            const phoneNumber = res.data[0].phone_number || '';
            this.phoneForm.controls['phone'].setValue(phoneNumber);

            if (!phoneNumber) {
              // Désactiver le placeholder lorsque le numéro est vide
              this.separateDialCode = false;
              this.phoneForm.controls['phone'].setValue('');
            }

            this.idUser = res.data[0].uuid;
            this.cvname = res.data[0].cv;

            if (res.data.cv) {
              this.file = { name: res.data.cv };
            }
          }
        });

    const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));

    // Ensure the input and country selector remain disabled
    this.preventCountryChange();

    // Handle existing email logic to toggle the phone input field
    this.checkEmailExistsAndTogglePhone();

    this.typeCompany = this.localStorageService.getData('userConnected');
    this.getListIntervenant();
    this.getListRole();
    this.toggleReadOnly();



    this.intervenantForm.get('linkedin_link')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        this.setValidatorRequirements();
      });

    this.intervenantForm.get('cv')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        this.setValidatorRequirements();
      });

    // Appelez la méthode une fois pour initialiser les validateurs
    this.setValidatorRequirements();


  }

  closeDropdownOnScroll(): void {
    // Find the open dropdown
    const dropdown = this.elRef.nativeElement.querySelector('.dropdown-menu.show');

    // If the dropdown is open, remove the 'show' class to close it without triggering a page scroll
    if (dropdown) {
      dropdown.classList.remove('show');
    }
  }
  checkEmailExistsAndTogglePhone() {
    if (this.isexistemail) {
        this.preventCountryChange();
    } else {
        this.phoneForm.controls['phone'].enable(); // Enable otherwise
        this.allowCountryChange();
    }
    this.phoneForm.controls['phone'].updateValueAndValidity();
}
preventCountryChange() {
  const phoneInput = this.phoneForm.get('phone');
  if (phoneInput) {
      // Add event listeners to block interaction
      const phoneInputElement = this.elRef.nativeElement.querySelector('.ngx-intl-tel-input');
      if (phoneInputElement) {
          phoneInputElement.addEventListener('mousedown', this.disableEvent);
          phoneInputElement.addEventListener('keydown', this.disableEvent);
          phoneInputElement.addEventListener('countryChange', this.preventCountryChange);
      }
  }
}
allowCountryChange() {
  const phoneInputElement = this.elRef.nativeElement.querySelector('.ngx-intl-tel-input');
  if (phoneInputElement) {
      phoneInputElement.removeEventListener('mousedown', this.disableEvent);
      phoneInputElement.removeEventListener('keydown', this.disableEvent);
      phoneInputElement.removeEventListener('countryChange', this.preventCountryChange);
  }
}

disableEvent(event: Event) {
  event.preventDefault();
  event.stopPropagation();
}
 //ADD
  onSearch(event: any): void {
    const term = event.target.value.trim();
    this.searchTerms.next(term); // Emit the current search term
  }
  toggleReadOnly() {
    if (this.isReadOnly) {
      this.renderer?.removeAttribute(this.inputField?.nativeElement, 'readonly');
    } else {
      this.renderer?.setAttribute(
        this.inputField?.nativeElement,
        'readonly',
        'true'
      );
    }
    this.isReadOnly = !this.isReadOnly;
  }
  onInputChange(data: any) {
    const phoneNumber = data.phoneNumber;
    this.validPhoneNumber = data.isNumberValid;
    this.intervenantForm.get('phone_number')?.setValue(phoneNumber);
  }
  handleKeyPress(event: any) {
    const allowedCharacters = /^[0-9+]+$/;

    if (!allowedCharacters.test(event.key)) {
      event.preventDefault();
    }
  }
  createFormPhone(data?: any) {
    return this.formBuilder.group({
      phone: [data && data.phone],
    });
  }
  iscv: boolean = false
  
  setValidatorRequirements() {
    const linkedinControl = this.intervenantForm.get('linkedin_link');
    const cvControl = this.intervenantForm.get('cv');

    // Effacer les validateurs existants
    linkedinControl?.clearValidators();
    cvControl?.clearValidators();

    if (!linkedinControl?.value && !cvControl?.value) {
      linkedinControl?.setValidators([
        Validators.pattern(linkedInRegExp),
      ]);
    } else {
      if (linkedinControl?.value) {
        linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
      }
      if (cvControl?.value) {
        cvControl?.clearValidators();
      }
    }

    linkedinControl?.updateValueAndValidity({ emitEvent: false });
    cvControl?.updateValueAndValidity({ emitEvent: false });
  }

onPageChange(e: PageEvent): void {
  this.pageSize = e.pageSize;
  this.currentPage = e.pageIndex;
  if (this.searchFormGroup.dirty) {
    this.applyFilter();
  }
  else {
    this.getListIntervenant();
  }
}

  /* list list esn companies */
  getListIntervenant() {
    this.spinner.show();

    const params = {
      type: 2,
      per_page: this.pageSize,
      page: this.currentPage
    } 
    this.companyService
      .getIntervenantList(params)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.isLoadSpinner = false;
          this.spinner.hide();
          this.listIntervenant = res.data.data;
          this.totalItems = res.data.total;
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  reset() {
    this.currentPage = 0;
    this.searchFormGroup.reset();
    this.searchFormGroup = this.createSearchForm();
    this.applyFilter();
  }
  resetCV() {
    const inputFile = document.getElementById('cv') as HTMLInputElement;
    if (inputFile) {
      inputFile.value = '';

      this.fileExtention = '';
      this.fileError = '';
    }
    this.fileName = '';
    this.showResetButtons = true;
  }

  /* delete intervenant pop up confirm or cancel */
  swallDeleteCat(intervenant: {
    uuid: string;
    first_name: string;
    last_name: string;
    id: number;
  }) {
    Swal.fire({
      title: `${confirmDelete} l'intervenant " ${intervenant.first_name} ${intervenant.last_name} " ? `,
      icon: 'question',
      showCancelButton: true,
      iconColor: '#ff0000',
      confirmButtonText: 'Supprimer',
      confirmButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteIntervenant(intervenant?.uuid);
      }
    });
  }
  /* delete intervenant */
  deleteIntervenant(uuid: string) {
    this.spinner.show();
    this.companyService
      .deleteIntervenant(uuid)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          if (res.status == 200) {
            this.applyFilter();
            this.spinner.hide();
            this.toastr.success(successDelete);
          }
        },
        error: (error) => {
          this.spinner.hide();
          if(error.error.message &&  error?.error?.message !== 'This role has SubWorkflowCras and cannot be deleted.'){
            this.toastrService.error('Le rôle de cet intervenant possède des Workflow et ne peut pas être supprimé');
          }
          else if (error?.error?.message && error?.error?.message === 'This role has SubWorkflowCras and cannot be deleted.') {
            const errorMessage = '"Le rôle de cet intervenant possède des Workflow et ne peut pas être supprimé"';
            this.toastrService.error(errorMessage);
          }
          else {
            this.toastrService.error(serverError);
          }
        },
      });
  }
  getRoleName(employeeRoleId: number): string {
    const role = this.listRole.find((role) => role.id === employeeRoleId);
    return role ? role.name : 'Role not found';
  }
  createIntervenantForm(data?: any) {    
    return this.formBuilder.group({
      first_name: [
        data && data.first_name,
        [Validators.required, Validators.pattern(patternfirstName)],
      ],
      last_name: [
        data && data.last_name,
        [Validators.required, Validators.pattern(patternfirstName)],
      ],
      emailProESN: [
        data && data.emailProESN,
        [Validators.pattern(patternEmail)],
      ],
      emailProClient: [
        data && data.emailProClient,
        [Validators.pattern(patternEmail)],
      ],
      email: [
        data && data.email,
        [Validators.required, Validators.pattern(patternEmail)],
      ],
      linkedin_link: [data && data.linkedin_link ? data.linkedin_link : ''],
      date_signature: [data && data.intervenant_date_signature],
      phone_number: [
        data && data.phone_number ? data.phone_number : '',
        [Validators.required],
      ],
      cv: [data && data.cv ? data.cv : ''],
      employee_role_id: [
        data && data.employee_role_id ? data.employee_role_id : null,
        [Validators.required],
      ],
      employee_id: [''],
    });
  }

  getListRole() {
    this.companyService
      .getListRoleByCompany()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.listRole = res.data?.filter((role: { name: string; }) => role.name !== "admin");;
        },
        error: () => { },
      });
  }
  onPhoneChange(event: any): void {
    // Suppose the event contains the phone number object from ngx-intl-tel-input
    if (event) {
      const phoneControl = this.phoneForm.get('phone');
      if (phoneControl) {
        phoneControl.setValue(event); // Update the form control value

        // If you need to update another form control based on phone number change
        const phoneNumber = event.internationalNumber; // Or however the event structure is
        this.intervenantForm.get('phone_number')?.setValue(phoneNumber);

        // Perform any additional actions you need when the phone number changes
        this.validPhoneNumber = phoneControl.valid; // Update the validity state
      }
    }
  }


  addInterveanant() {

    this.intervenantForm.markAllAsTouched();
    this.intervenantForm.markAsDirty();

    this.spinner.show();
    if (!this.isexistemail) {
      const phonee = this.phoneForm.get('phone')?.value;
      const phoneNumberr = phonee ? phonee.internationalNumber : '';
      this.intervenantForm.get('phone_number')?.setValue(phoneNumberr);
      this.setValidatorRequirements();
      let fromdata = new FormData();

      if (this.intervenantForm.value.emailProESN) {
        fromdata.append('emailProESN', this.intervenantForm.value.emailProESN);
      } else {
        fromdata.append('emailProESN', '');
      }
      fromdata.append('first_name', this.intervenantForm.value.first_name);
      fromdata.append('last_name', this.intervenantForm.value.last_name);
      fromdata.append('email', this.intervenantForm.value.email);

      fromdata.append(
        'date_signature',
        this.intervenantForm.value.date_signature
      );

      if (this.intervenantForm.value.employee_role_id) {
        fromdata.append(
          'linkedin_link',
          this.intervenantForm.value.linkedin_link
        );
      } else {
        fromdata.append('linkedin_link', '');
      }

      fromdata.append('employee_id', this.intervenantForm.value.employee_id);
      if (this.intervenantForm.value.employee_role_id) {
        fromdata.append(
          'employee_role_id',
          this.intervenantForm.value.employee_role_id
        );
      } else {
        fromdata.append('employee_role_id', '');
      }

      const phone = this.phoneForm.get('phone')?.value;
      const phoneNumber = phone ? phone.internationalNumber : '';
      this.intervenantForm.get('phone_number')?.setValue(phoneNumber);

      fromdata.append('phone_number', this.intervenantForm.value.phone_number || '');

      if (this.file) {
        fromdata.append('cv', this.file);
      } else {
        fromdata.append('cv', '');
      }
      this.companyService
        .createIntervenant(fromdata)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.getListIntervenant();
            this.toastr.success(addedIntervenant);
            this.closeModal();
            this.intervenantForm.reset();
          },
          error: (err) => {
            this.spinner.hide();
            let errorMessage = '';
            if (err?.error?.message) {
              if (typeof err?.error?.message === 'string') {
                this.toastr.error(err.error.message, 'Une erreur s\'est produite', {
                  timeOut: 5000,
                });
                return;
              }

              const emailErrorMessage = err.error.message.email;

              if (
                emailErrorMessage &&
                emailErrorMessage[0] === 'The email has already been taken.'
              ) {
                errorMessage = associatedIntervenant1;
                this.toastr.error(errorMessage);
              } else if (err.error.message['emailProESN']) {
                errorMessage = emailExist;
                this.toastr.error(errorMessage);
              } else if (err.error.message['email']) {
                errorMessage = personalEmailExist;
                this.toastr.error(errorMessage);
              } else if (err.error.message['phone_number']) {
                errorMessage = phoneNumberExist;
                this.toastr.error(errorMessage);
              } else if (err.error.message['name']) {
                errorMessage = existedIntervenant;
                this.toastr.error(errorMessage);
              } else if (err?.error && err?.error?.message &&
                err?.error?.message === 'Company already has a responsable'
              ) {
                errorMessage = existedManager;
                this.toastr.error(errorMessage);
              } else if (
                err.error.message.includes(
                  'employee already associated to another company.'
                )
              ) {
                errorMessage = associatedIntervenant;
                this.toastr.error(errorMessage);
              } else if (
                err.error.message.includes(
                  'employee already associated to this company.'
                )
              ) {
                errorMessage = associatedIntervenant2;
                this.toastr.error(errorMessage);
              }
              else if (err.status === 403 && err.error.message) {
                this.toastr.error(err.error.message);
              }
            }
          },
        });
    } else {
      let payloadData = {
        user_id: this.idUser,
        emailProESN: this.intervenantForm.value.emailProESN,
        employee_role_id: this.intervenantForm.value.employee_role_id
          ? this.intervenantForm.value.employee_role_id
          : '',
        date_signature: this.intervenantForm.value.date_signature
          ? this.intervenantForm.value.date_signature
          : '',
      };
      this.companyService
        .createIntervenant(payloadData)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.getListIntervenant();
            this.toastr.success(addedIntervenant);
            this.closeModal();
            this.intervenantForm.reset();
          },
          error: (err) => {

            this.spinner.hide();
            let errorMessage = '';
            if (err?.error?.message) {

              if (typeof err?.error?.message === 'string') {
                this.toastr.error(err.error.message, 'Une erreur s\'est produite', {
                  timeOut: 5000,
                });
                return;
              }

              const emailErrorMessage = err.error.message.email;

              if (
                emailErrorMessage &&
                emailErrorMessage[0] === 'The email has already been taken.'
              ) {
                errorMessage = associatedIntervenant1;
                this.toastr.error(errorMessage);
              } else if (err.error.message['emailProESN']) {
                errorMessage = emailExist;
                this.toastr.error(errorMessage);
              } else if (err.error.message['email']) {
                errorMessage = personalEmailExist;
                this.toastr.error(errorMessage);
              } else if (err.error.message['phone_number']) {
                errorMessage = phoneNumberExist;
                this.toastr.error(errorMessage);
              } else if (err.error.message['name']) {
                errorMessage = existedIntervenant;
                this.toastr.error(errorMessage);
              } else if (
                err?.error?.message?.includes('Company already has a responsable')
              ) {
                errorMessage = existedManager;
                this.toastr.error(errorMessage);
              } else if (
                err.error.message.includes(
                  'employee already associated to another company.'
                )
              ) {
                errorMessage = associatedIntervenant;
                this.toastr.error(errorMessage);
              } else if (
                err.error.message.includes(
                  'employee already associated to this company.'
                )
              ) {
                errorMessage = associatedIntervenant2;
                this.toastr.error(errorMessage);
              }

              // Show Toastr error message
              if (errorMessage) {
                this.toastr.info(errorMessage);
              }
            }
          },
        });
    }
  }



  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });
    if (data) {
      this.idIntervenant = data.uuid;
      this.intervenantForm = this.createIntervenantForm(data);
      this.phoneForm.get('phone')?.setValue(data.phone_number);
      const phone = this.phoneForm.get('phone')?.value;
      this.intervenantForm
        .get('phone_number')
        ?.setValue(phone?.internationalNumber);
      this.intervenantForm.get('cv')?.setValue(data.cv);
      this.cvname = data.cv;
      if (mode == 'details') {
        this.intervenantForm.get('employee_role_id')?.disable();
      }
      if (mode == 'ajouter') {
        this.phoneForm.controls['phone'].enable();
        this.cvname = '';
      }
      if (mode == 'modifier') {
        this.cvname = '';
      }
    }
  }
  openModaladd(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });

    this.phoneForm.controls['phone'].enable();
        this.cvname = '';


    }

  updateIntervenant() {
    this.intervenantForm.get('employee_id')?.setValue(this.idIntervenant);
    const phone = this.phoneForm.get('phone')?.value;
    this.intervenantForm
      .get('phone_number')
      ?.setValue(phone?.internationalNumber);
      const updatePayload = { ...this.intervenantForm.value };

    if(this.file){
      updatePayload.cv = this.file
    }
    delete updatePayload.phone_number;
    this.spinner.show();

    const formData = new FormData();
    Object.entries(updatePayload).forEach(([key, value]) => {
    if (key === 'cv' && value instanceof Blob) {
      formData.append(key, value);
    } else {
      formData.append(key, String(value ?? ''));
    }
    })

    this.companyService
      .updateIntervenant(formData)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.closeModal();

          this.spinner.hide();
          this.getListIntervenant();
          this.toastr.success(updatedIntervenant);
          this.closeModal();
          this.intervenantForm.reset();
        },
        error: (err) => {
          this.spinner.hide();
          let errorMessage = '';
          
          if (err?.error?.message) {
            const emailErrorMessage = err.error.message.email;

            if (
              emailErrorMessage &&
              emailErrorMessage[0] === 'The email has already been taken.'
            ) {
              errorMessage = associatedIntervenant1;
            } else if (err.error.message['emailProESN']) {
              errorMessage = emailExist;
            } else if (err.error.message['email']) {
              errorMessage = personalEmailExist;
            } else if (err.error.message['phone_number']) {
              errorMessage = phoneNumberExist;
            } else if (err.error.message['name']) {
              errorMessage = existedIntervenant;
            } else if (
              err.error.message.includes('Company already has a responsable')
            ) {
              errorMessage = existedManager;
            } else if (
              err.error.message.includes(
                'employee already associated to another company.'
              )
            ) {
              errorMessage = associatedIntervenant;
            } else if (
              err.error.message.includes(
                'employee already associated to this company.'
              )
            ) {
              errorMessage = associatedIntervenant2;
            }
            else if (err?.error && err.status===400 && err?.error?.message &&
              err?.error?.message === 'This role has SubWorkflowCras and cannot be updated.'
            ) {
               const errorMessage = '"Ce rôle est lié à des workflows actifs et ne peut pas être modifié"';
              this.toastr.error(errorMessage);
            }
            if (errorMessage) {
              this.toastr.info(errorMessage);
            }
          }
        },
      });
  }


  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: ['', data?.name],
      role: [data?.role ? data?.role : null],
    });
  }

  applyFilter() {
    let data = {
      name: this.searchFormGroup.value.name,
      role: this.searchFormGroup.value.role,
      per_page: this.pageSize,
      page: this.currentPage
    };
    this.spinner.show();
    this.companyService
      .searchInterveanant(data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listIntervenant = res.data?.data;
          this.totalItems = res.data.total;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }


  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
    // const scrollableTable = this.elRef.nativeElement.querySelector('#kt_customers_table');
    // scrollableTable?.addEventListener('scroll', this.closeDropdownOnScroll.bind(this));

  }

  closeModal() {
    this.modalRef!.hide();
    this.intervenantForm.reset();
    this.phoneForm.reset();
    this.iscv = false
    this.cvname = ""
    this.showResetButtons = false;
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  uploadFile(event: any) {
    this.file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024;
    this.fileName = this.file.name;
    if (this.file) {
      const allowedExtensions = ['.pdf', '.docx', '.doc'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));

      if (!allowedExtensions.includes(fileExtension)) {
        this.fileExtention = 'Format fichier non compatible !';
      } else if (this.file.size > maxSize) {
        this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
      } else {
        this.fileError = '';
        this.fileExtention = '';
      }
    }
    this.intervenantForm.get('cv')?.setValue(this.file);
  }

  isFileNameCompatible(): boolean {
    if (!this.file) {
      return false; // Aucun fichier sélectionné
    }

    const allowedExtensions = ['.pdf', '.docx', '.doc'];
    const fileExtension = this.file.name
      .toLowerCase()
      .substr(this.file.name.lastIndexOf('.'));
    return allowedExtensions.includes(fileExtension);
  }

  updateNavigation(intervenant: any) {
    intervenant.date_signature = intervenant.intervenant_date_signature
    this.intervenantSelectedService.setIntervenantSelected(intervenant);
    this.router.navigate(['/intervenants/modification-intervenant']);
  }


}
